

export const postContact = async (contact) => {

  return new Promise(async (resolve, reject) => {

    try {

      const response = await fetch("/api/v1/support/contact/", {
        method: "POST",
        body: JSON.stringify(contact),

        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
        },

      });

      let json = await response.json();
      //console.log('response', json)

      if (response.status >= 400 && response.status < 600) {
        throw new Error(json);
      }
      resolve(json);
    } catch (e) {
      reject(e);
    }
  });
};

export const requestDemoService = async (contact) => {

  return new Promise(async (resolve, reject) => {

    try {

      const response = await fetch("/api/v1/support/contact/demoRequests", {
        method: "POST",
        body: JSON.stringify(contact),

        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
        },

      });

      let json = await response.json();

      if (response.status >= 400 && response.status < 600) {
        const apiError =
          json?.errors?.[0]?.msg ||
          json?.message ||
          "Failed to submit demo request. Please try again.";
        throw new Error(apiError);
      }
      resolve(json);
    } catch (e) {
      reject(e);
    }
  });
};
